import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Koiro.css';

function Koiro() {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const paras = sectionRef.current?.querySelectorAll('p');
    if (!paras) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('para--in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.05 });
    paras.forEach((p, i) => {
      p.style.transitionDelay = `${i * 0.1}s`;
      obs.observe(p);
    });
    return () => obs.disconnect();
  }, []);

  return (
    <section className="about-section" ref={sectionRef}>
      <span className="about-kicker">KOIRO</span>
      <h2>{t('koiro.title')}</h2>
      <p dangerouslySetInnerHTML={{ __html: t('koiro.p1') }} />
      <p dangerouslySetInnerHTML={{ __html: t('koiro.p2') }} />
      <p dangerouslySetInnerHTML={{ __html: t('koiro.p3') }} />
      <p dangerouslySetInnerHTML={{ __html: t('koiro.p4') }} />
    </section>
  );
}

export default Koiro;
